<div class="row bottom-margin-30px">
  <div class="col-lg-6">
    <h3 class="header-text font-size-7 margin-left-8">
      <strong>{{cmsModel.DCReviewTitle}}</strong>
    </h3>
  </div>
</div>

<div class="col-sm-10 offset-sm-1">
  <div id="beEditDC" block-ui="BEDeliveryCommitmentEdit">
    <!-- DC Information Section -->
    <div class="border-bottom-dashed">
      <div class="padding-top-30px padding-bottom-30px fhlb-blue-font">
        <strong>{{cmsModel.DCInformationText}}</strong>
      </div>
      <div class="row padding-bottom-20px">
        <div class="col-sm-7">
          <div class="row padding-bottom-10px">
            <div class="col-sm-6 text-align-right-sm">
              <label class="control-label">{{cmsModel.AuthorizedByBE}}</label>
            </div>
            <div class="col-sm-6 padding-left-0px feedback-display-font padding-top-7 text-word-wrap">
              {{dcMainModel.dcDetails.authorizedByName}}
            </div>
          </div>
          <div class="row padding-bottom-10px">
            <div class="col-sm-6 text-align-right-sm">
              <label class="control-label">{{cmsModel.EmailAddressText}}</label>
            </div>
            <div class="col-sm-6 padding-left-0px feedback-display-font padding-top-7 text-word-wrap">
              {{dcMainModel.dcRequestModel.bankUser.emailAddress}}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 text-align-right-sm">
              <label class="control-label">{{cmsModel.MasterCommitmentNumber}}:</label>
            </div>
            <div class="col-sm-6 padding-left-0px padding-top-7px feedback-display-font">
              {{dcExistingModel.deliveryCommitment.masterCommitmentId}}
            </div>
          </div>
          <div class="row padding-bottom-10px">
            <div class="col-sm-6 text-align-right-sm">
              <label class="control-label">{{cmsModel.DeliveryTypeText}}:</label>
            </div>
            <div class="col-sm-6 padding-left-0px feedback-display-font padding-top-7px">
              {{dcExistingModel.deliveryCommitment.deliveryType}}
            </div>
          </div>
          <div class="row padding-bottom-10px">
            <div class="col-sm-6 text-align-right-sm">
              <label class="control-label">{{cmsModel.DeliveryAmountText}}:</label>
            </div>
            <div class="col-sm-6 padding-left-0px padding-top-7px feedback-display-font">
              {{dcExistingModel.deliveryCommitment.dcAmount | currency}}
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="row">
            <div class="col-sm-6 text-align-right-sm">
              <label class="control-label">{{cmsModel.Product}}:</label>
            </div>
            <div class="col-sm-6 padding-left-0px padding-top-7px feedback-display-font">
              {{productSelected}}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 text-align-right-sm">
              <label class="control-label">{{cmsModel.SubProductText}}</label>
            </div>
            <div class="col-sm-6 padding-left-0px padding-top-7px feedback-display-font">
              {{dcExistingModel.deliveryCommitment.subProductName}}
            </div>
          </div>
           <div class="row">
      <div class="col-sm-6 control-label text-align-right-sm">
        <label>{{cmsModel.CommitmentTermExpDateText}}</label>
      </div>
        <div class="col-sm-6 padding-left-0px form-group mb-3 text-align-left padding-top-7px">
          <div class="feedback-display-font">
              {{dcExistingModel.deliveryCommitment.commitmentTerm}} - Days {{dcExistingModel.deliveryCommitment.originalDeliveryDate | date:'MM/dd/yyyy'}}
        </div>
        </div>
      </div>
      <div class="row padding-bottom-10px">
        <div class="col-sm-6 control-label padding-top-0px text-align-right-sm">
          <label>{{cmsModel.ExpirationDateText}}</label>
        </div>
        <div class="col-sm-4 padding-left-0px text-align-left font-weight-100 margin-left-0px">
          <div class="feedback-display-font">
            {{dcExistingModel.deliveryCommitment.originalDeliveryDate | date:'MM/dd/yyyy'}}
          </div>
        </div>
      </div>
<div class="row padding-bottom-10px">
        <div class="col-sm-6 control-label text-align-right-sm padding-top-0px">
          <label>{{cmsModel.ScheduleText}}</label>
        </div>
        <div class="col-sm-4 padding-left-0px text-align-left margin-left-0px">
          <div class="feedback-display-font font-weight-100">
            {{dcExistingModel.deliveryCommitment.scheduleCode}}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 control-label text-align-right-sm">
          <label>{{cmsModel.NoteRate}}: </label>
        </div>
        <div class="col-sm-4 padding-left-0px form-group mb-3">
          <input type="text" id="noteRate" name="noteRate" class="form-control" #noteRateControl
                 [(ngModel)]="noteRatePercent" required real-time-percent
                 allowPositiveNegative="false" allowDecimalNumbers #noteRate="ngModel" show-errors disabled />
        </div>
      </div>
        </div>
             
      
      
      </div>

    </div>
  </div>
  <app-bestefforts-read-only-data [bestEffortsDeliveryData]="bestEffortsDeliveryData" [dcExistingModel]="dcExistingModel" [cmsModel]="cmsModel" [propertyTypeOptions]="propertyTypeOptions" [loanPurposesOptions]="loanPurposesOptions"></app-bestefforts-read-only-data>
  <div class="row col-sm-12 padding-bottom-15px">
    <div class="col-sm-2 offset-sm-4">
      <input type="submit" class="btn btn-default blackButton fw-bold" value="CANCEL" (click)="cancelDC()" />
    </div>
    <div class="col-sm-2">
      <input type="submit" class="btn btn-default blackButton fw-bold" value="CHANGE" (click)="changeDC()" />
    </div>
    <div class="col-sm-2">
      <input type="submit"
             class="btn btn-success background-image-none feedback-form-button form-control padding-right-10px background-image-none fw-bold"
        value="SUBMIT" id="dc-edit-be" name="dc-edit-be" (click)="onSubmitReview()" />
    </div>
  </div>
</div>
